import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { toast } from "sonner";

const KEY = "fd-cookie-consent";

export default function CookieEinstellungen() {
  const [necessary] = useState(true);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (v === "all") {
      setAnalytics(true);
      setMarketing(true);
    }
  }, []);

  const save = () => {
    const value = analytics && marketing ? "all" : analytics ? "analytics" : marketing ? "marketing" : "necessary";
    localStorage.setItem(KEY, value);
    toast.success("Cookie-Einstellungen gespeichert.");
  };

  return (
    <div className="min-h-screen bg-white" data-testid="cookies-page">
      <Header />
      <main className="pt-28 md:pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#0A3B2C] hover:underline mb-8" data-testid="cookies-back-link">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>

          <div className="flex items-center gap-3 mb-3">
            <Cookie className="h-5 w-5 text-[#0A3B2C]" />
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C]">Cookies & Datenschutz</div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0A3B2C] mb-6" style={{ fontFamily: "Outfit, sans-serif" }}>
            Cookie-Einstellungen
          </h1>

          <p className="text-base text-gray-600 leading-relaxed mb-10 max-w-2xl">
            Wir respektieren Ihre Privatsphäre. Notwendige Cookies sind erforderlich, damit die Seite
            technisch fehlerfrei funktioniert (z. B. Kontaktformular). Mit Ihrer Einwilligung
            verwenden wir zusätzlich Analyse- und Marketing-Cookies, um unser Angebot zu verbessern.
          </p>

          <div className="space-y-4">
            <CookieRow
              testId="cookie-row-necessary"
              title="Notwendige Cookies"
              desc="Erforderlich für die grundlegende Funktion der Website (z. B. Sitzung, Kontaktformular)."
              checked={necessary}
              disabled
              onChange={() => {}}
            />
            <CookieRow
              testId="cookie-row-analytics"
              title="Analyse-Cookies"
              desc="Helfen uns zu verstehen, wie Besucher unsere Website nutzen, damit wir sie verbessern können."
              checked={analytics}
              onChange={setAnalytics}
            />
            <CookieRow
              testId="cookie-row-marketing"
              title="Marketing-Cookies"
              desc="Ermöglichen personalisierte Inhalte und Anzeigen."
              checked={marketing}
              onChange={setMarketing}
            />
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              onClick={save}
              data-testid="cookies-save-btn"
              className="bg-[#0A3B2C] text-white hover:bg-[#072A1F] px-6 py-3 rounded-md text-sm font-semibold transition"
            >
              Auswahl speichern
            </button>
            <button
              onClick={() => { setAnalytics(true); setMarketing(true); localStorage.setItem(KEY, "all"); toast.success("Alle Cookies akzeptiert."); }}
              data-testid="cookies-accept-all-btn"
              className="bg-white text-[#0A3B2C] border border-[#0A3B2C]/20 hover:border-[#0A3B2C] px-6 py-3 rounded-md text-sm font-semibold transition"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function CookieRow({ title, desc, checked, onChange, disabled, testId }) {
  return (
    <div className={`border rounded-xl p-5 ${checked ? "border-[#0A3B2C]/30 bg-[#F0F5F2]/40" : "border-gray-200 bg-white"}`} data-testid={testId}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-base font-semibold text-[#0A3B2C]" style={{ fontFamily: "Outfit, sans-serif" }}>
            {title}
          </div>
          <p className="text-sm text-gray-600 mt-1 leading-relaxed">{desc}</p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer shrink-0 mt-1">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => !disabled && onChange(e.target.checked)}
            disabled={disabled}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-[#0A3B2C] transition-colors relative">
            <div className={`absolute top-0.5 left-0.5 h-5 w-5 bg-white rounded-full shadow transition-transform ${checked ? "translate-x-5" : ""}`} />
          </div>
        </label>
      </div>
    </div>
  );
}
